import {
  ItemQuestion,
  Question,
  ItemQuestionDragNDrop,
} from "@/models/quiz.model";
import { defineStore } from "pinia";
import { instance } from "./index";

export enum QuestionType {
  DEFAULT,
  DRAG_AND_DROP,
  TRUE_OR_FALSE,
  GAP,
}

const store = defineStore({
  id: "quiz-questions-gap",
  state: () => ({
    form: {
      id: "",
      prompt: "",
      items: [] as any,
    } as Question,
    items: [] as any,
    responses: [] as any,
    senteceForm: {} as ItemQuestionDragNDrop,
    selectCorrect: false as boolean,
    isAdaptive: false as boolean,
    gaps: [] as { name: string; id: string; itemGroup: number }[],
    v$: {} as any,
    v$Dialog: {} as any,
    responseContent: {} as any,
  }),
  getters: {
    getItemsFormLength: (state) => {
      const items = [...state.form.items];
      return items.length;
    },
  },
  actions: {
    setForm(value: Question) {
      Object.assign(this.form, value);
    },
    setSelectCorrect(value) {
      this.selectCorrect = value;
    },
    setIsAdaptive(value) {
      this.isAdaptive = value;
    },
    setV(value) {
      this.v$ = value;
    },
    setVDialog(value) {
      this.v$Dialog = value;
    },
    setGaps(value) {
      this.gaps = value;
    },
    setSentenceForm(value) {
      this.senteceForm = value;
    },
    setItems(value) {
      this.items.push(value);
    },
  
    setResponses(value) {
      this.responses = [...this.responses, ...value];
    },
    resetResponses() {
      this.responses = [];
    },
  },
});

export const useQuizQuestionsGapStore = store(instance);
